// Import plugin.
import React from 'react';
import ReactDOM from 'react-dom';
import easyScroll from 'easy-scroll';

class FloatBtn extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      
    };
  }
  
  scrollTop(){
    easyScroll({
      'scrollableDomEle': window,
      'direction': 'top',
      'duration': 300,
      'easingPreset': 'easeOutQuint',
      'scrollAmount': 1000
    });
  }
  
  render(){
    return(
      <div id="floating" className="floating--bottom" onClick={ this.scrollTop }></div>
    );
  }
}

export default FloatBtn;